export default "__VITE_ASSET__ClWsyjY1__"